import { Link } from "react-router-dom";
import { RECURRING_JOBS_REPORT_TABLE_HEADER } from "../../../constant/tableHeadersConstants/Jobs/recurringJobReportTableHeader";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { RecurringJobReportListType } from "../../../redux/jobs/jobsType";
import { CircularAvatar } from "../../commons";
import GstTableHeader from "../../Gst/common/GstTableHeader";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
type AppProps = {
  data: RecurringJobReportListType[] | [];
  tableHeader: TableHeadersType[];
  setData: any;
  handleRedirectToRecurringJobSetting: (data: any) => void;
};
const RecurringJobReportTableData = ({
  data,
  tableHeader,
  handleRedirectToRecurringJobSetting,
}: AppProps) => {
  const handleSetLocalStorageData = (itemData: any) => {
    localStorage.setItem("client_code", itemData?.client_code);
    localStorage.setItem("client_name", itemData?.client_name);
  };
  return (
    <>
      {data?.length > 0 &&
        data?.map((singleData: any, index: number) => {
          const finalData = {
            clientCode: singleData?.client_code,
            companyName: singleData?.client_name,
          };
          return (
            <>
              <tr>
                {tableHeader?.map((header: TableHeadersType) => {
                  if (header?.value === "client_name") {
                    return (
                      <td colSpan={2}>
                        <div>
                          <div
                            className="d-flex justify-content-sm-start"
                            style={{ gap: "10px" }}
                          >
                            <div>
                              <Link
                                target="_blank"
                                to={`/jobs/recurring-jobs/edit/${singleData?.client_code}`}
                                onClick={() =>
                                  handleSetLocalStorageData(singleData)
                                }
                                style={{
                                  color: "#262a44",
                                  cursor: "pointer",
                                  textDecoration: "none",
                                }}
                              >
                                <span
                                  className="pointer"
                                  style={{
                                    textDecoration: "underline",
                                    color: "#262a44",
                                    fontWeight: "600",
                                    fontSize: "16px",
                                    textUnderlineOffset: "3px",
                                  }}
                                >
                                  {`${singleData?.client_name} (${singleData?.client_code})`}
                                  <span></span>
                                </span>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </td>
                    );
                  }
                })}
              </tr>

              <tr>
                <td>
                  <table className="table table-bordered">
                    <thead className="thead-light">
                      <GstTableHeader
                        tableHeader={RECURRING_JOBS_REPORT_TABLE_HEADER}
                      />
                    </thead>

                    <tbody>
                      {singleData?.jobs?.length > 0 &&
                        singleData?.jobs?.map((insideData: any) => {
                          return (
                            <>
                              <tr>
                                {RECURRING_JOBS_REPORT_TABLE_HEADER?.map(
                                  (header: TableHeadersType) => {
                                    if (header?.value == "job_type_name") {
                                      return (
                                        <td style={{ maxWidth: "139px" }}>
                                          {insideData?.job_type_name?.length <
                                          15 ? (
                                            <div className="text_color">
                                              {insideData?.job_type_name}
                                            </div>
                                          ) : (
                                            <OverlayTrigger
                                              placement="top"
                                              delay={{ show: 250, hide: 250 }}
                                              overlay={
                                                <Tooltip id="button-view-open-item">
                                                  {insideData?.job_type_name}
                                                </Tooltip>
                                              }
                                            >
                                              <div
                                                className="text_color"
                                                style={{ width: "100%" }}
                                              >
                                                {insideData?.job_type_name?.slice(
                                                  0,
                                                  15
                                                ) + "..."}
                                              </div>
                                            </OverlayTrigger>
                                          )}
                                        </td>
                                      );
                                    } else if (header?.value == "description") {
                                      return (
                                        <td style={{ minWidth: "204px" }}>
                                          {insideData?.description?.length <
                                          35 ? (
                                            <div className="text_color">
                                              {insideData?.description}
                                            </div>
                                          ) : (
                                            <OverlayTrigger
                                              placement="top"
                                              delay={{ show: 250, hide: 250 }}
                                              overlay={
                                                <Tooltip id="button-view-open-item">
                                                  {insideData?.description}
                                                </Tooltip>
                                              }
                                            >
                                              <div
                                                className="text_color"
                                                style={{ width: "100%" }}
                                              >
                                                {insideData?.description?.slice(
                                                  0,
                                                  35
                                                ) + "..."}
                                              </div>
                                            </OverlayTrigger>
                                          )}
                                        </td>
                                      );
                                    } else if (
                                      header?.value == "engagement_cutoff_date"
                                    ) {
                                      return (
                                        <td>
                                          {insideData?.engagement_cutoff_date
                                            ? insideData?.engagement_cutoff_date
                                            : "--/--"}
                                        </td>
                                      );
                                    } else if (header?.value == "manager") {
                                      return (
                                        <td>
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "left",
                                              alignItems: "start",
                                              gap: "7px",
                                            }}
                                          >
                                            <div>
                                              <CircularAvatar
                                                name={`${
                                                  insideData?.manager
                                                    ?.first_name
                                                    ? insideData?.manager
                                                        ?.first_name
                                                    : ""
                                                } ${
                                                  insideData?.manager?.last_name
                                                    ? insideData?.manager
                                                        ?.last_name
                                                    : ""
                                                }`}
                                                image={
                                                  insideData?.manager
                                                    ?.profile_pic &&
                                                  insideData?.manager
                                                    ?.profile_pic?.file_url
                                                }
                                              />
                                            </div>
                                            <div>
                                              <span>
                                                {
                                                  insideData?.manager
                                                    ?.first_name
                                                }{" "}
                                                {insideData?.manager?.last_name}
                                              </span>
                                            </div>
                                          </div>
                                        </td>
                                      );
                                    } else if (header?.value == "responsible") {
                                      return (
                                        <td>
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "left",
                                              alignItems: "start",
                                              gap: "7px",
                                            }}
                                          >
                                            <div>
                                              <CircularAvatar
                                                name={`${
                                                  insideData?.responsible
                                                    ?.first_name
                                                    ? insideData?.responsible
                                                        ?.first_name
                                                    : ""
                                                } ${
                                                  insideData?.responsible
                                                    ?.last_name
                                                    ? insideData?.responsible
                                                        ?.last_name
                                                    : ""
                                                }`}
                                                image={
                                                  insideData?.responsible
                                                    ?.profile_pic &&
                                                  insideData?.responsible
                                                    ?.profile_pic?.file_url
                                                }
                                              />
                                            </div>
                                            <div>
                                              <span>
                                                {
                                                  insideData?.responsible
                                                    ?.first_name
                                                }{" "}
                                                {
                                                  insideData?.responsible
                                                    ?.last_name
                                                }
                                              </span>
                                            </div>
                                          </div>
                                        </td>
                                      );
                                    }
                                  }
                                )}
                              </tr>
                            </>
                          );
                        })}
                    </tbody>
                  </table>
                </td>
              </tr>
            </>
          );
        })}
    </>
  );
};

export default RecurringJobReportTableData;
